import React, { Fragment } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import PublicHeader from "web/components/PublicHeader";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import Button from "web/components/Button";
import TextInput from "web/components/form-elements/TextInput";
import PublicNavbar from "web/components/PublicNavbar";
// import Footer from "web/components/Footer";

import "./publicLayout.scss";

const PublicLayout = ({ children, transparentHeader, paddingTop, tabType}) => {
  const INITIAL_VALUES = {
    email: "",
  };
  const VALIDATION_SCHEMA = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email.")
      .required("Email is required.")
      // .matches(/^[a-zA-Z0-9_!#$%&amp;'*+/=?`{|}~^.-]+@[a-zA-Z0-9-]+(.com|.net|.co.in|.org|.int.edu|.gov|mil|.int|.edu|.cc|.co.uk|us){1}$/,"Please enter a valid email."),
  });
  return (
    <Fragment>
      <Helmet>
        <meta name="viewport" content="width=device-width" />
      </Helmet>
      <div
        className={`app-container ${transparentHeader ? "guest-header" : ""}`}
      >
        <PublicNavbar tabType={tabType}/>
        <div className={`app-body ${paddingTop ? "app-body-top-padding" : ""}`}>
          {children}
        </div>
      </div>
    </Fragment>
  );
};

PublicLayout.propTypes = {
  transparentHeader: PropTypes.bool,
  paddingTop: PropTypes.bool,
};

PublicLayout.defaultProps = {
  transparentHeader: false,
  paddingTop: false,
};

export default PublicLayout;
